export default __webpack_public_path__ + "static/media/icon-select-arrow.70bd087c.svg";